var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18073 6.36364C4.18073 6.16281 4.34354 6 4.54437 6H7.45346C7.65429 6 7.81709 6.16281 7.81709 6.36364C7.81709 6.56447 7.65429 6.72727 7.45346 6.72727H4.54437C4.34354 6.72727 4.18073 6.56447 4.18073 6.36364Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54437 7.45455C4.34354 7.45455 4.18073 7.61735 4.18073 7.81818C4.18073 8.01901 4.34354 8.18182 4.54437 8.18182H7.45346C7.65429 8.18182 7.81709 8.01901 7.81709 7.81818C7.81709 7.61735 7.65429 7.45455 7.45346 7.45455H4.54437Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36255 3.09091C2.36255 2.48842 2.85097 2 3.45346 2H6.72618C6.82263 2 6.91512 2.03831 6.98331 2.10651L9.52877 4.65196C9.59696 4.72016 9.63528 4.81265 9.63528 4.90909V8.90909C9.63528 9.51158 9.14686 10 8.54437 10H3.45346C2.85097 10 2.36255 9.51158 2.36255 8.90909V3.09091ZM3.45346 2.72727C3.25263 2.72727 3.08982 2.89008 3.08982 3.09091V8.90909C3.08982 9.10992 3.25263 9.27273 3.45346 9.27273H8.54437C8.7452 9.27273 8.908 9.10992 8.908 8.90909V5.27273H7.45346C6.85097 5.27273 6.36255 4.78431 6.36255 4.18182V2.72727H3.45346ZM7.08982 3.24153L8.39374 4.54545H7.45346C7.25263 4.54545 7.08982 4.38265 7.08982 4.18182V3.24153Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.be4af271d467fb2fad887fbeecd994ab.svg";
export { ForwardRef as ReactComponent };